"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsonCtrl_1 = __importDefault(require("./jsonCtrl"));
var jsonTransparent_1 = __importDefault(require("./jsonTransparent"));
var jsonTransparentNotCheckRaw_1 = __importDefault(require("./jsonTransparentNotCheckRaw"));
exports.default = (function (virtual) { return ({
    JSON_CTRL: jsonCtrl_1.default(virtual),
    JSON_TRANSPARENT: jsonTransparent_1.default(virtual),
    JSON_TRANSPARENT_NOT_CHECK_RAW: jsonTransparentNotCheckRaw_1.default(virtual)
}); });



// WEBPACK FOOTER //
// ./src/decode/decode.ts